import { generateSecret as generate } from '../runtime/generate.js';
export async function generateSecret(alg, options) {
    return generate(alg, options);
}



// WEBPACK FOOTER //
// ./~/jose/dist/browser/key/generate_secret.js